/**
 * Check whether an updatedBy or createdBy field is a user, rather than an app client.
 * @param maybeUser
 * @returns
 */
export function isUser(maybeUser: string | null | undefined): boolean {
  return maybeUser?.includes('las:user:') || false;
}
